import { NavLink, Link, Outlet, useLocation } from 'react-router-dom';
import { Sun, ShieldCheck, CalendarCheck, Settings } from 'lucide-react';
import { useStore, hMinus } from '../lib/store';

const NAV = [
  { to: '/app', end: true, label: 'Hari Ini', icon: Sun, testid: 'nav-bottom-home' },
  { to: '/app/persiapan', label: 'Persiapan', icon: CalendarCheck, testid: 'nav-bottom-persiapan' },
  { to: '/app/transaksi', label: 'Vendor & Pembayaran', icon: ShieldCheck, testid: 'nav-bottom-transaksi' },
];

export function BottomNav() {
  const { pathname } = useLocation();
  const txnActive = pathname.startsWith('/app/transaksi') || pathname.startsWith('/app/vendor') || pathname.startsWith('/app/pembayaran');
  return (
    <nav className="fixed bottom-0 inset-x-0 z-40">
      <div className="mx-auto w-full max-w-md lg:max-w-xl bg-white/92 backdrop-blur-md border-t border-ink/10 shadow-[0_-8px_30px_-18px_rgba(30,42,74,0.35)]">
        <div className="grid grid-cols-3">
          {NAV.map(({ to, end, label, icon: Icon, testid }) => (
            <NavLink
              key={to}
              to={to}
              end={end}
              data-testid={testid}
              className={({ isActive }) => {
                const active = isActive || (to === '/app/transaksi' && txnActive);
                return `flex flex-col items-center gap-1 py-2.5 text-[10px] font-semibold transition-colors ${
                  active ? 'text-ink' : 'text-slate-400 hover:text-slate-500'
                }`;
              }}
            >
              {({ isActive }) => {
                const active = isActive || (to === '/app/transaksi' && txnActive);
                return (
                  <>
                    <span className={`relative flex items-center justify-center w-10 h-7 rounded-full transition-colors ${active ? 'bg-ink/8' : ''}`}>
                      <Icon size={19} strokeWidth={active ? 2.4 : 1.8} />
                      {active && <span className="absolute -bottom-0.5 w-1 h-1 rounded-full bg-terra" />}
                    </span>
                    {label}
                  </>
                );
              }}
            </NavLink>
          ))}
        </div>
      </div>
    </nav>
  );
}

export default function Shell() {
  const { state } = useStore();
  const p = state?.profile;
  return (
    <div className="min-h-svh">
      <header className="sticky top-0 z-30 bg-ivory/85 backdrop-blur-md border-b border-ink/8">
        <div className="mx-auto w-full max-w-md lg:max-w-xl px-5 py-3.5 flex items-center justify-between">
          <div>
            <p data-testid="shell-couple-name" className="font-serif text-base font-semibold text-ink leading-tight">{p?.coupleName}</p>
            <p className="font-mono text-[10px] tracking-wide text-slate-500">
              {hMinus(p?.weddingDate)}{p?.city ? ` · ${p.city}` : ''}
            </p>
          </div>
          <div className="flex items-center gap-2">
            {p?.demoMode && (
              <span data-testid="demo-mode-badge" className="rounded-full border border-gold/50 bg-gold/10 text-[10px] font-mono uppercase tracking-widest text-[#8a6d1c] px-2.5 py-1">
                Mode Demo
              </span>
            )}
            <Link data-testid="settings-link" to="/app/pengaturan" className="w-9 h-9 rounded-full border border-ink/12 bg-white flex items-center justify-center text-ink hover:bg-bone transition-colors">
              <Settings size={16} />
            </Link>
          </div>
        </div>
      </header>
      <main className="mx-auto w-full max-w-md lg:max-w-xl px-5 pt-5 pb-32">
        <Outlet />
      </main>
      <BottomNav />
    </div>
  );
}
